'use strict';

categoryService.$inject = ["api", "Category", "CategoryWithSubcategories", "$cacheFactory", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryService = categoryService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function categoryService(api, Category, CategoryWithSubcategories, $cacheFactory, gettextCatalog) {
    var cache = $cacheFactory('myCache');

    return {
        getMenuCategories: getMenuCategories,
        getById: getById,
        getCategoryTreeInArrayById: getCategoryTreeInArrayById
    };

    function getAll() {
        // var cachedCategories = cache.get('categories');
        // if (!angular.isUndefined(cachedCategories)) {
        //     return $q.when(cachedCategories);
        // }

        return api.categories.list({ ParentId: null, CategoryTypeIds: [] }).$promise.then(function (resourceList) {
            var categories = _lodash2.default.map(resourceList, function (resource) {
                return Category.create(resource);
            });

            cache.put('categories', categories);
            return categories;
        });
    }

    function getMenuCategories() {
        return api.categoriesMenu.get().$promise.then(function (resourceList) {
            var categories = _lodash2.default.map(resourceList, function (resource) {
                return Category.create(resource);
            });

            cache.put('categories', categories);
            categories = getCategoriesWithSubcategories(categories, null, 1);
            return categories;
        });
    }

    function getById(categoryId) {
        if (categoryId === 0) {
            return {
                name: gettextCatalog.getString('All products')
            };
        } else if (categoryId === undefined) {
            return null;
        }

        return api.category.get({ id: categoryId }).$promise.then(function (resource) {
            return Category.create(resource);
        });
    }

    function getCategoryTreeInArrayById(id) {
        return getAll().then(function (categories) {
            if (id === 0) {
                return categories;
            }

            var list = [];

            var category = _lodash2.default.find(categories, { id: id });
            while (category) {
                list.push({ id: category.id, name: category.name });
                category = _lodash2.default.find(categories, {
                    id: category.parentCategoryId
                });
            }

            return list;
        });
    }

    /// private stuff

    function getCategoriesWithSubcategories(categories, parentCategoryId, level) {
        var list = [];

        for (var i = 0; i < categories.length; i++) {
            var cat = categories[i];
            if (cat.parentCategoryId === parentCategoryId) {
                var newCat = {
                    id: cat.id,
                    name: cat.name,
                    subcategories: level >= 2 ? null : getCategoriesWithSubcategories(categories, cat.id, level + 1)
                };
                list.push(newCat);
            }
        }

        return list.length === 0 ? null : list;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/categoryService.js
// module id = 804
// module chunks = 0